import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'redux';

function Register(props) {

    const [ accessCode, setAccessCode ] = useState();

    var firstName;
    var lastName;
    var ucfid;
    const navigate = useNavigate();
    const location = useLocation();
    
    const handleRegister = async event => {
        // event.preventDefault();
        var obj = {
            ucf_id: ucfid.value,
            firstname: firstName.value,
            lastname: lastName.value,
        };
        var js = JSON.stringify(obj);
        try{
            await axios.post(`${process.env.REACT_APP_API_HOST}/api/auth/updateRegister`,
            {            
                ucf_id: ucfid.value,
                first_name: firstName.value,
                last_name: lastName.value,
                access_code: accessCode,
            })
        }catch(err){
            console.log("error: " + err);
            navigate("/");
        }
        navigate("/");

    }

    const checkAccess = async(access) => {

        try{
            await axios.post(`${process.env.REACT_APP_API_HOST}/api/auth/checkAccess`,
            {
                access_code: access,
            })
            .then((response) => {
                if(response.status !== 200){
                    navigate("/placeholder");
                }
            })
        }catch(err){
            console.log("error: " + err);
            navigate("/");
        }
    }

    useEffect(() => {

        const access = location.pathname.split('/')[2]
        setAccessCode(access);
        checkAccess(access);

        if(null === undefined){
            navigate("/")
        }
    }, []);


    return (
        <div className='loginSection'
            style={{alignContent:'center', 
            alignItems: 'center', 
            justifyContent:'center', 
            // width: '100vw',
            // height:'100vh',
            }}>

            <p>Create Account</p>
                <form onSubmit = {handleRegister}>
                    <input type="text" className="loginField" placeholder="First Name" ref ={(c) => firstName = c} required/><br/>
                    <input type="text" className="loginField" placeholder="Last Name" ref ={(c) => lastName = c} required/><br/>
                    <input type="text" className="loginField" placeholder="UCFID" ref ={(c) => ucfid = c} required/><br/>
                    <input type="submit" className="UCFbutton" onClick={handleRegister}/><br/>
                </form>
        </div>
    )
}

export default Register
